'use client';

import { useSyncExternalStore } from 'react';
import { getIconRegistryVersion, subscribeIconRegistry } from './icons';

/**
 * Re-renders the caller when the lazily loaded full Lucide set registers, so a
 * resolveIcon() that missed the static map is retried. Returns the version.
 */
export function useIconRegistryVersion(): number {
  return useSyncExternalStore(subscribeIconRegistry, getIconRegistryVersion, () => 0);
}
